<script>
  import Layout from '@layout/main'
  // import { KEYWORD } from "@src/config/fake-data";
  import { searchCategoryList } from "@utils/filter-value-to-text"
  import { searchOptions } from "@utils/zerone-options";
  import createDownloadLink from '@utils/create-download-link'
  import setWindowHistory from "@utils/window-history";
  import DialogLogin from '@components/Dialog/Login';
  import DialogDealer from '@components/Dialog/Dealer';
  import DialogDealerGroup from '@components/Dialog/DealerGroup';
  import { authComputed } from '@store/helpers'

  export default {
    page() {
      return {
        title: `站內搜尋`,
      }
    },
    components: {
      Layout,
      DialogLogin,
      DialogDealer,
      DialogDealerGroup,
    },
    props: {
      list: {
        type: Array,
        default: () => ([
          {
            title: 'Aimetis',
            description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。為企業提供全面整合真正的自動化安全基礎架構，無虛擬環境、雲端環境還從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。',
            to: {
              name: 'brand-item',
              params: {
                brandAlias: 'Aimetis'
              }
            },
            data: {
              routeName: 'brand-item',
              breadcrumbTitle: 'Aimetis'
            }
          },
          {
            title: 'Aimetis',
            description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。為企業提供全面整合真正的自動化安全基礎架構，無虛擬環境、雲端環境還從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。',
            to: {
              name: 'brand-item',
              params: {
                brandAlias: 'Aimetis'
              }
            },
            data: {
              routeName: 'brand-item',
              breadcrumbTitle: 'Aimetis'
            }
          },
          {
            title: 'Aimetis',
            description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。為企業提供全面整合真正的自動化安全基礎架構，無虛擬環境、雲端環境還從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。',
            to: {
              name: 'brand-item',
              params: {
                brandAlias: 'Aimetis'
              }
            },
            data: {
              routeName: 'brand-item',
              breadcrumbTitle: 'Aimetis'
            }
          },
          {
            title: 'Aimetis',
            description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。為企業提供全面整合真正的自動化安全基礎架構，無虛擬環境、雲端環境還從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。',
            to: {
              name: 'brand-item',
              params: {
                brandAlias: 'Aimetis'
              }
            },
            data: {
              routeName: 'brand-item',
              breadcrumbTitle: 'Aimetis'
            }
          },
          {
            title: 'Aimetis',
            description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。為企業提供全面整合真正的自動化安全基礎架構，無虛擬環境、雲端環境還從事內部部署，為每個網路區段、設備、設備與設備間提供無與倫比的保護和可視性。',
            to: {
              name: 'brand-item',
              params: {
                brandAlias: 'Aimetis'
              }
            },
            data: {
              routeName: 'brand-item',
              breadcrumbTitle: 'Aimetis'
            }
          },
        ])
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      },
      page: {
        type: Number,
        default: 1,
      }
    },
    data() {
      return {
        isDialogLoginVisible: false,
        isDialogDealerVisible: false,
        isDialogDealerGroupVisible: false,
        callbackLogin: () => {
        },
        keywordList: [],
        hotKeyword: [],
        keyword: this.$route.query.tag ? [this.$route.query.tag] : [],
        filterClassList: searchOptions(),
        filterClass: this.$route.query.filterClass
          ? this.$route.query.filterClass.split(',')
          : [],
        query: this.$route.query.query || '',
        menuList: searchCategoryList,
        // searchList: [],
        isShowFilterMenu: false,
        filterType: 'click',
        isfilterdone: false,
        routeNameMap: {
          solution: "brand-solution-item",  // solutionAlias
          case: "brand-case-item",  // brandAlias caseAlias
          bulletin: "brand-news-item",  // categoryAlias newsAlias
          promotion: "brand-news-item",  // categoryAlias newsAlias
          video: "brand-video-item",  // videoAlias
          brand: "brand-item",  // brandAlias
          file: "file",
          event: 'brand-event-item',
          product: 'brand-product-item'
        },
        searchList: this.list || [],
        searchPagination: this.pagination || {},
        filterLoading: false,
        filedoading: false,
        indexClicked: undefined
      }
    },
    computed: {
      ...authComputed,
      totalPage() {
        return Math.ceil(this.searchPagination.total / 10)
      },
      buttonBarList() {
        return [
          {
            text: '確定',
            class: 'flex-grow-1',
            buttonClass: 'isStylePrimary isRadius isSmall isFull',
            onClick: () => {
              this.changeFilter()
            },
          },
          {
            text: '取消',
            class: 'flex-grow-1',
            buttonClass: 'isStyleDark isOutline2 isRadius isSmall isFull',
            onClick: () => {
              this.isShowFilterMenu = false
            },
          },
        ]
      },
      filterList() {
        return [
          {
            text: '結果篩選',
            alias: 'filterClass',
            list: this.filterClassList,
            selectData: this.filterClass,
            buttonClass: 'isStylePrimary isOutline2 isDelete'
          },
          {
            text: '關鍵字',
            alias: 'tag',
            list: this.keywordList,
            selectData: this.keyword,
            buttonClass: 'isStylePrimary isOutline2 isDelete'
          },
        ]
      }
    },
    created() {
      this.getKeywordList()
    },
    mounted() {
      const initResizeListener = () => {
        window.addEventListener('resize', this.setFilterType)
      };

      this.setFilterType();
      initResizeListener();
    },
    destroyed() {
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.setFilterType)
      };

      removeResizeListener();
    },
    methods: {
      async getKeywordList() {
        const keywords =  await this.$store.dispatch("global/fetchKeyword")
        this.hotKeyword = keywords.filter((item) => item.hot === 1)
        this.keywordList = keywords
        this.tryToFetchKeyWordClick(this.$route.query.tag)
      },
      filterCategoryTitle(singleAlias, filterList) {
        const result = () => filterList.find((item) => {
          return item.alias === singleAlias
        })
        if(result()) {
          this.isfilterdone = true
          return result().title
        }
        this.isfilterdone = true
        return false
      },
      deleteFilterCategory(item, filterCategory) {
        filterCategory.splice(item, 1)
        if(this.filterType === 'prompt') {
          this.changeFilter()
        }
      },
      changeFilter(val) {
        // this.goToFilter()
        const query = () => {
          const query = {
            filterClass: this.filterClass.length > 0
              ? this.filterClass.join(',')
              : undefined,
            tag: this.keyword.length > 0
              ? this.keyword[0]
              : undefined,
            query: this.query ?? undefined,
          }
          return query;
        };
        setWindowHistory({
          query: {
            ...this.$route.query,
            page: 1,
            ...query()
          }
        });
        this.tryToFetchSearchList({
          page: 1
        }).then(()=> {
          if(this.filterType === 'click') {
            this.isShowFilterMenu = false
          }
        })
      },
      // goToFilter() {
      //   this.$router.push({
      //     name: this.$route.name,
      //     params: this.$route.params,
      //     query: {
      //       ...this.$route.query,
      //       filterClass: this.filterClass.length > 0
      //         ? this.filterClass.join(',')
      //         : undefined,
      //       query: this.$route.query.query || undefined,
      //     }
      //   })
      // },
      setFilterType() {
        this.filterType = document.body.clientWidth > 767
          ? 'prompt'
          : 'click';
      },
      onShowFilterMenu(status) {
        this.isShowFilterMenu = status
      },
      onChangePagination(page) {
        this.tryToFetchSearchList({
          page
        }).then(() => {
            const url = new URL(window.location)
            let params = url.searchParams;
            if(params.has('page')) {
              this.$scrollToElement({
                $el: this.$refs['sectionList'],
                offset: 200,
              });
            }
        })
      },
      async tryToFetchSearchList(storeParams) {
        this.filterLoading = true;
        const params = {
          type: this.filterClass.length 
            ? this.filterClass
            : [],
          search: this.query ?? undefined,
          tag: this.keyword[0] ?? undefined,
          limit: 10,
          ...storeParams
        }
        await this.$store.dispatch('global/searchArticle', params)
          .then(({ items,pagination }) => {
            const setData = () => {
              this.searchList = items;
              this.searchPagination = pagination;
              // this.featuredList = featured
            };

            setData();
            
          })
          .finally(() => {
            this.filterLoading = false;
          })
      },
      async tryToFetchKeyWordClick(alias) {
        const tag = this.keywordList.find((item) => item.alias === alias)
        if(tag) {
          await this.$store.dispatch('global/fetchKeywordClick', alias)
        }
        
      },
      onClickKeyword(keyword) {
        this.keyword[0] = keyword.alias 
        if(this.filterType === 'click') {
          return 
        }
        setWindowHistory({
          query: {
            page: 1,
            tag: keyword.alias,
          }
        });
        this.tryToFetchKeyWordClick(keyword.alias)
        this.tryToFetchSearchList({
          page: 1,
          tag: keyword.alias,
        });
      },
      onClearSearch() {
        this.filterClass = [];
        this.keyword = [];
        const query = () => {
          const query = {
            ...this.$route.query,
            query: this.query = undefined,
            filterClass: undefined,
            page: undefined,
            tag: this.tag = undefined,
          }
          return  query
        }
        setWindowHistory({
          query: {
            ...query(),
            // page: 1
          }
        });
        this.tryToFetchSearchList({
          storeParams: {
            page: 1,
          }
        });
      },
      redirectTo(item) {
        let brandAlias = item.brands[0]
        let categoryAlias = item.contentType
        let aliasPrefix = this.routeNameMap[item.contentType].split('-')[1]
        // if(['promotion'].includes(item.contentType)) {
        //   categoryAlias = 'promotion'
        // }
        // /* if (['case', 'solution'].includes(contentType))
        //  brandAlias = brands[0].alias */
        if(['brand'].includes(item.contentType)) {
          aliasPrefix = this.routeNameMap[item.contentType].split('-')[0]
        }
        if(aliasPrefix === 'news' && item.userGroupId === 6) {
          this.isDealerView({
            name: this.routeNameMap[item.contentType],
            params: {
              categoryAlias,
              brandAlias,
              [`${ aliasPrefix }Alias`]: item.alias,
              eventSeriesNum: item.seriesNum
            }
          })
        } else {
          this.$router.push({
            name: this.routeNameMap[item.contentType],
            params: {
              categoryAlias,
              brandAlias,
              [`${ aliasPrefix }Alias`]: item.alias,
              eventSeriesNum: item.seriesNum
            }
          })
        }        
      },
      isDealerView(to) {
        const loggedInFn = () => {
          this.isDialogLoginVisible = false;
          this.$nextTick(() => {
            if(this.currentMember?.groupId !== 6) {
              this.isDialogDealerGroupVisible = true
            } else {
              this.$router.push(to)
            }
          })
        };

        if(this.loggedIn) {
          loggedInFn()
        } else {
          this.callbackLogin = () => {
            loggedInFn()
          };
          this.isDialogDealerVisible = true
        }
      },
      async handleDownloadFile(file, index) {
        this.indexClicked = index
        this.filedoading = true;
        const response = await this.$store.dispatch('global/fetchFile', {
          url: file.downloadLink,
          responseType: 'blob'
        });

        createDownloadLink(file.title||file.name, response);
        this.filedoading = false;
      },
      showLogin(val) {
        this.isDialogLoginVisible = val
        this.isDialogDealerVisible = false
      },
      showDownload(file) {
        let result; 
        if(file.userGroupId === 6){ 
          if( this.loggedIn && this.currentMember.groupId === 6 ) { 
            if(file.downloadLink) {
              result = 'canDownLoad'
            } else {
              result = 'DealerNotVali'
            }
          } else {
            result = 'DealerOnly'
          }
        } else if(file.userGroupId === 7) {
          if(this.loggedIn) {
            result = 'canDownLoad'
          } else {
            result = 'groupOnly'
          }
        } else {
          result = 'canDownLoad'
        }
        return result
      }
    }
  }
</script>
<template>
  <Layout>
    <BaseBanner
      title="站內搜尋"
      :image="require('@assets/images/search/banner.png')"
      custom-class="isStyleWhite"
      @openFilter="onShowFilterMenu(!isShowFilterMenu)"
    />
    <section :class="$style.sectionSearch" class="section ">
      <div class="container">
        <div class="mb-lg-5 mb-3 d-md-block d-none">
          <BaseSearch
            v-model="query"
            title=""
            class="mb-4 sectionSearch__search isStyleIcon"
            @search="changeFilter"
          />
          <BaseKeyword
            title="熱門關鍵字:"
            class="d-flex mb-4 mb-lg-5 sectionSearch__keyword flex-md-row flex-column"
            :list="hotKeyword"
            :active="keyword"
            @click="onClickKeyword"
          />
        </div>
        <div v-if="$route.query" class="row">
          <div class="col-lg-3 mb-lg-5 mb-lg-0">
            <BaseFilterBox
              :is-show-filter="isShowFilterMenu" 
              @showFilterMenu="onShowFilterMenu"
            >
              <div class="mb-4 d-md-none">
                <div class="text-base mb-4">已篩選條件</div>
                <div class="row mobileGutter">
                  <template v-for="filter in filterList">
                    <template v-if="filter.list.length && filter.selectData.length">
                      <div   
                        v-for="(item,$index2) in filter.selectData"
                        :key="item"
                        class="col-6"
                      >
                        <BaseButton
                          v-if="filterCategoryTitle(item, filter.list)"
                          :class="filter.buttonClass"
                          class="isFull isRadius isEllipsis"
                          @click="deleteFilterCategory($index2,filter.selectData)"
                        >
                          {{ filterCategoryTitle(item, filter.list) }}
                          <i class="fal fa-times icon"></i>
                        </BaseButton>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
              <BaseSearch
                v-model="query"
                title="搜尋"
                title-class="d-none d-lg-block"
                class="d-md-none"
                @search="changeFilter"
              />
              <div class="sectionSolutuinList__filterBox">
                <BaseFilter
                  v-model="filterClass"
                  title="結果篩選"
                  title-class="d-flex d-md-none d-lg-flex"
                  class="isSingle"
                  :list="filterClassList"
                  :type="filterType"
                  @changeFilter="changeFilter"
                />
              </div>
              <BaseKeyword
                title="熱門關鍵字"
                class="d-md-none d-flex mt-4 sectionSearch__keyword flex-md-row flex-column"
                :list="hotKeyword"
                :active="keyword"
                @click="onClickKeyword"
              />
              <BaseButtonBar
                :button-list="buttonBarList"
                is-show
                class="d-md-none"
              />
            </BaseFilterBox>
          </div>
          <div ref="sectionList" v-loading="filterLoading" class="col-lg-9 mt-lg-0 mt-5">
            <div v-if="!!filterClass.length || !!keyword.length" class="d-md-flex d-none mb-3">
              <template v-for="filter in filterList">
                <template v-if="filter.list.length && filter.selectData.length">
                  <div   
                    v-for="(item,$index2) in filter.selectData"
                    :key="item"
                    class="mr-2"
                  >
                    <BaseButton
                      v-if="filterCategoryTitle(item, filter.list)"
                      :class="filter.buttonClass"
                      @click="deleteFilterCategory($index2,filter.selectData)"
                    >
                      {{ filterCategoryTitle(item, filter.list) }}
                      <i class="fal fa-times icon"></i>
                    </BaseButton>
                  </div>
                </template>
              </template>
            </div>
            <template v-if="searchList.length" >
              <div class="text-base color-gray-6 ">
                共 {{ searchPagination.total }} 項結果 ｜ 第 {{ searchPagination.current_page }} 頁（共 {{ totalPage }} 頁）
              </div>
              <ul :class="$style.searchList" class="mb-5">
                <li
                  v-for="(searchItem, index) in searchList"
                  :key="index"
                  class="searchList__item"
                >
                  <div
                    v-if="searchItem.contentType === 'file'"
                    v-loading="filedoading && indexClicked === index"  
                  >
                    <template  v-if="!!searchItem.size || !!searchItem.webLink">
                      <template v-if="showDownload(searchItem) === 'canDownLoad'">
                        <a 
                          v-if="searchItem.linkType === 'url'"
                          class="searchList__title" 
                          :href="searchItem.webLink"
                          target="_blank"
                        >
                          {{ searchItem.title }}
                          <span>
                            <i class='icomoon icon-download'></i>
                          </span> 
                        </a>
                        <div
                          v-else
                          class="searchList__title"  
                          @click="handleDownloadFile(searchItem, index)"
                        >
                          {{ searchItem.title }} 
                          <span>
                            <i class='icomoon icon-download'></i>
                          </span>
                        </div> 
                      </template>
                      <div 
                        v-else-if="showDownload(searchItem) === 'groupOnly'"
                        class="searchList__title isNotHoverStyle"
                      >
                        {{ searchItem.title }} 
                        <span class="badge"> 會員限定下載 </span>
                      </div>
                      <div 
                        v-else
                        class="searchList__title isNotHoverStyle"
                      >
                        {{ searchItem.title }}
                        <span class="badge"> {{ showDownload(searchItem) === 'DealerNotVali' ? '經銷會員未驗證' : '經銷商限定下載'}} </span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="searchList__title isNotHoverStyle">
                        {{ searchItem.title }} 
                      </div>
                    </template>
                    <div class="searchList__description" v-html="searchItem.description"></div>
                    <BaseBreadcrumb
                      type="search"
                      class="searchList__breadcrumb d-md-block d-none"
                      :data="{ routeName: routeNameMap[searchItem.contentType] }"
                    />
                  </div>
                  <div 
                    v-else
                    @click="redirectTo(searchItem)"
                  >
                    <div class="searchList__title">
                      {{ searchItem.title }} 
                      <template 
                        v-if="searchItem.userGroupId === 6 
                        && (searchItem.contentType === 'bulletin' || searchItem.contentType === 'promotion')"
                      >
                        <span class="badge ml-auto"> 經銷商限定 </span>
                      </template>
                    </div> 
                    <div class="searchList__description" v-html="searchItem.description"></div>
                    <BaseBreadcrumb
                      type="search"
                      class="searchList__breadcrumb d-md-block d-none"
                      :data="{ routeName: routeNameMap[searchItem.contentType] }"
                    />
                  </div>
                </li>
              </ul>
              <BasePagination2
                :pagination="searchPagination"
                @change="onChangePagination"
              />
            </template>
            <BaseNull 
              v-else
              is-search-null 
              @clearSearch="onClearSearch"
            />
          </div>
        </div>
      </div>
    </section>
    <DialogDealerGroup
      :visible.sync="isDialogDealerGroupVisible"
    />
    <DialogDealer
      :visible.sync="isDialogDealerVisible"
      @isShowlogin="showLogin"
    />
    <DialogLogin
      :visible.sync="isDialogLoginVisible"
      @login="callbackLogin"
    />
  </Layout>
</template>
<style lang="scss" module>
  .sectionSearch {
    :global {
      .sectionSearch {
        &__search {
          .baseSearch {
            &__searchBox {
              width: 100%;

              .el-input {
                position: relative;

                &::before {
                  position: absolute;
                  top: 50%;
                  left: 3.1rem;
                  font-family: 'Font Awesome 5 Pro';
                  font-size: 1.5rem;
                  color: $color-gray-5;
                  content: '\f002';
                  transform: translateY(-50%);
                }

                &__inner {
                  height: 80px;
                  padding-left: 6.375rem;
                }
              }
            }

            &__submitBox {
              .baseButton {
                min-width: 229px;
                height: 80px;

                @include max-md {
                  min-width: 150px;
                }
              }
            }
          }
        }

        &__keyword {
          .baseKeyword {
            &__title {
              height: 33px;
              margin-right: 1rem;
              // margin-bottom: 0;
              line-height: 33px;
            }

            &__keywordList__item {
              // margin-right: 1.25rem;
            }
          }
        }
      }
    }
  }

  .searchList {
    @include list-unstyled;

    :global {
      .searchList {
        &__item {
          padding: 2.5rem 0;
          border-bottom: 1px solid #B1BACA;
        }

        &__title {
          display: block;
          margin-bottom: 1.25rem;
          font-weight: 500;
          color: $color-gray-7;
          cursor: pointer;

          &:hover {
            color: $color-primary;
            text-decoration: none;
          }
          &.isNotHoverStyle {
            cursor: inherit;
            &:hover {
              color: inherit;
            }
          }
        }

        &__description {
          margin-bottom: 1.25rem;
          line-height: 2;
          color: $color-gray-5;

          @include line-clamp(2, 4em)
        }

        &__breadcrumb {
          margin-left: -15px;
        }
      }
    }
  }
</style>
